export default __webpack_public_path__ + "static/media/bookThree.1f8835c6.png";